module.exports = __webpack_public_path__ + "img/add.a2eb17d9.svg";